import { FunctionComponent } from 'preact';
import { useSelector } from 'react-redux';
import { getTitleTooltipId } from '../../htmlElements/htmlElementsIdGetter';
import { ToolTip } from '../../../../common/components/toolTip/toolTip';
import { TOOLTIP_POSITIONS } from '../../../../common/components/toolTip/toolTip.contants';
import { useStyles } from '../../../../common/hooks/useStyles';
import { isDesktopMode } from '../../../../common/utils/utils';
import { playerDataSelector } from '../../../../common/store/selectors/playerData.selector';
import { videoDataSelector } from '../../../../common/store/selectors/videoData.selector';
import { brandingDataSelector } from '../../../../common/store/selectors/brandingData.selector';
import { splitViewSelector } from '../../../../common/store/selectors/splitView.selector';
import { getTitleStyleObject } from './title.style';
import { anchorDataSelector } from '../../../../common/store/selectors/anchorData.selector';
import { anchorOptionsSelector } from '../../../../common/store/selectors/anchorOptions.selector';
import { TitleText } from './titleText';

export const Title: FunctionComponent = () => {
  const playerUniqueId = useSelector(playerDataSelector.playerInstanceUniqId);
  const title = useSelector(videoDataSelector.title);
  const brandingLogoSrc = useSelector(brandingDataSelector.brandingLogoSrc);
  const playerSize = useSelector(playerDataSelector.playerSize);
  const splitViewRatio = useSelector(splitViewSelector.splitViewRatio);
  const playerMode = useSelector(playerDataSelector.playerMode);
  const anchorStatus = useSelector(anchorDataSelector.anchorStatus);
  const canClose = useSelector(anchorOptionsSelector.canClose);

  const showLogo = brandingLogoSrc !== '';
  const showShareIcon = false;
  const desktopMode = isDesktopMode(playerMode);
  const closableAnchor = anchorStatus === 'active' && canClose;

  const styles = useStyles(getTitleStyleObject, [showLogo, showShareIcon, playerSize, splitViewRatio, closableAnchor]);
  const { titleStyle, titleAndToolTipContainerStyle } = styles;

  return (
    <div style={titleAndToolTipContainerStyle}>
      {desktopMode
        ? (
          <ToolTip content={title} position={TOOLTIP_POSITIONS.BOTTOM} id={getTitleTooltipId(playerUniqueId)}>
            <TitleText titleStyle={titleStyle} />
          </ToolTip>
        )
        : <TitleText titleStyle={titleStyle} />}
    </div>
  );
};
